import React from 'react';
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogTitle, DialogContent } from './Dialog';


export { useDialog } from './Dialog';

export default function SmsTermsDialog({ open, toggle }:{ open: boolean, toggle: () => null }) {
  return (
    <Dialog id="sms-terms-dialog" toggle={toggle} open={open}>
      <DialogTitle onClose={toggle}>
        <FormattedMessage description="smsTermsDialogTitle" defaultMessage="SMS Terms" />
      </DialogTitle>

      <DialogContent>
        <FormattedMessage
          description="smsTermsDialogTitle"
          defaultMessage='By entering a number and clicking “Sign Up” you agree to receive status updates for this
order sent via text. Message and data rates may apply. Reply STOP to cancel.'
        />
      </DialogContent>
    </Dialog>
  );
}
